const ENGAGEMENT_SIGNAL_LABELS = {
  emailOpenCount: "Email opens (+2)",
  emailClickCount: "Email clicks (+5)",
  emailReplyCount: "Email replies (+15)",
  linkedinConnectionAcceptedCount: "LinkedIn accepts (+8)",
  linkedinMessageReadCount: "LinkedIn reads (+2)",
  linkedinMessageReplyCount: "LinkedIn replies (+15)",
  whatsappMessageReadCount: "WhatsApp reads (+2)",
  whatsappMessageReplyCount: "WhatsApp replies (+15)",
};

const getActiveSignals = (rawSignals = {}) =>
  Object.entries(ENGAGEMENT_SIGNAL_LABELS)
    .map(([key, label]) => ({ label, value: Number(rawSignals?.[key] || 0) }))
    .filter((signal) => signal.value !== 0);

export const EngagementScoreBreakdown = ({
  score,
  breakdown,
  campaignName,
}) => {
  if (!breakdown || breakdown === "N/A") {
    return (
      <p className="text-xs text-gray-500 dark:text-gray-400 text-wrap break-words">
        No engagement signals found yet.
      </p>
    );
  }

  const activeSignals = getActiveSignals(breakdown.rawSignals);
  const temperature = String(breakdown.temperature || "cold");

  return (
    <div className="max-h-[min(360px,60vh)] w-[min(320px,calc(100vw-32px))] space-y-3 overflow-y-auto overscroll-contain pr-1 touch-pan-y [-webkit-overflow-scrolling:touch]">
      <div>
        <p className="text-[13px] font-semibold text-gray-900 dark:text-gray-100">
          Engagement counts
        </p>
        {campaignName ? (
          <p className="mt-0.5 text-[11px] text-gray-500 dark:text-gray-400">{campaignName}</p>
        ) : null}
        <p className="mt-1 text-[11px] font-medium capitalize text-gray-700 dark:text-gray-300">
          {temperature} · {score ?? 0}/100
        </p>
        <p className="mt-1 text-[11px] leading-relaxed text-gray-500 dark:text-gray-400">
          Unique prospect actions from the last {breakdown.windowDays || 30} days.
        </p>
      </div>
      <div>
        <div>
          <p className="mb-1.5 text-xs font-medium text-gray-800 dark:text-gray-200">
            Signals counted
          </p>
          {activeSignals.length ? (
            <div className="flex flex-wrap gap-1.5">
              {activeSignals.map(({ label, value }) => (
                <span
                  key={label}
                  className="rounded-full bg-white dark:bg-gray-800 px-2 py-0.5 text-[11px] text-gray-600 dark:text-gray-300 ring-1 ring-gray-200 dark:ring-gray-700"
                >
                  {label}: {value}
                </span>
              ))}
            </div>
          ) : (
            <p className="text-[11px] text-gray-500 dark:text-gray-400">
              No positive or negative signals yet.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
